import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostProcat(action) {
	try {
		const result = yield fromApi.procatPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_PROCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetProcats(action) {
	try {
		const result = yield fromApi.procatsGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_PROCATS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutProcat(action) {
	try {
		const result = yield fromApi.procatPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_PROCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutProcatOrdre(action) {
	try {
		const result = yield fromApi.procatOrdrePut(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_PROCATORDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelProcat(action) {
	try {
		const result = yield fromApi.procatDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_PROCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* procats() {
	yield takeLatest('POST_PROCAT_SAGAS', watchPostProcat);
	yield takeLatest('GET_PROCATS_SAGAS', watchGetProcats);
	yield takeLatest('PUT_PROCAT_SAGAS', watchPutProcat);
	yield takeLatest('PUT_PROCATORDRE_SAGAS', watchPutProcatOrdre);
	yield takeLatest('DEL_PROCAT_SAGAS', watchDelProcat);
}

export default function* rootSaga() {
	yield all([procats()]);
}
